import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { hot } from "react-hot-loader/root";
import { ConfigProvider } from "antd";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import { Platform, Auth} from "./components";
import HeadBar from "./ui/head-bar";
import "./index.less";
import { getQuery } from "@/service/http";
import { useStores } from "./store";
import {
  Booking,
  Deal,
  Offers,
  Restaurant,
  Vouchers,
  H5,
  Points,
  MyReviews,
  Profile,
  ResCollection,
  Home,
  Ctrip,
  DynamicPage,
  Explore,
  RedemptionVoucher,
  Download
} from "./pages";
import "@/service/resize";
import matomoinit from "./service/matoma";

function App() {
  const [isFinished, setIsFinished] = useState(false);
  const { region_id, region, regionId, openVoucher } = getQuery();
  const { memberStore, CommonStore } = useStores();
  const locale = memberStore.getLocale();
  const [isClearSearch, setIsClearSearch] = useState(false);
  const hostWidgetRef = useRef(null);
  useEffect(() => {
    // 初始化matomo
    matomoinit();
  }, []);
  useEffect(() => {
    const element = hostWidgetRef.current;

    if (!element) {
      return undefined;
    }
    element.locale = locale.locale;
    element.regionId = region || region_id || regionId;
    element.env =
      process.env.REACT_APP_MODE === "PRODUTION" ? "production" : "staging";

    const handleEvent = (event) => {
      const { type, detail } = event;
      switch (type) {
        case "open-change":
          hostWidgetRef.current.open = detail?.open === true;
          if(detail?.open) {
            document.body.classList.add("is-login");
          } else {
            document.body.classList.remove("is-login");
          }
          break;
        case "login-success":
          window.private_token = detail?.data.private_token;
          localStorage.setItem("private_token", window.private_token);
          window.location.reload();
          break;

        default:
          break;
      }
    };

    element.addEventListener("login-success", handleEvent);
    element.addEventListener("open-change", handleEvent);

    return () => {
      element.removeEventListener("login-success", handleEvent);
      element.removeEventListener("open-change", handleEvent);
    };
  }, [locale]);

  CommonStore.getFooterDetail(region || region_id || regionId).then(() => {
    setIsFinished(true);
    document.body.classList.add("loaded");
  });
  return (
    <>
      <dc-login
        ref={hostWidgetRef}
        id="loginWidget"
        locale={locale?.locale}
        region-id={region || region_id || regionId}
        env={
          process.env.REACT_APP_MODE === "PRODUTION" ? "production" : "staging"
        }
      ></dc-login>
      <Auth>
        <Router>
          <ConfigProvider locale={locale}>
            <div className="page-main">
              <HeadBar hidden={!!openVoucher} isClearSearch={isClearSearch} />
              <Switch>
                <Route path="/points" component={Points}></Route>
                <Route path="/profile" component={Profile}></Route>
                <Route path="/home" component={Home}></Route>
                <Route path="/collection" component={ResCollection}></Route>
                <Route path="/dynamicPage" component={DynamicPage}></Route>
                <Route path="/download" component={Download}></Route>
              </Switch>
              <main>
                <Switch>
                  <Route path="/Invite-friends" component={Ctrip}></Route>
                  <Route
                    path="/ctrip-restaurant-collection"
                    component={Ctrip}
                  ></Route>
                  <Route path="/my-bookings" component={Booking}></Route>
                  <Route
                    path="/browse"
                    render={() => (
                      <Explore
                        setIsClearSearch={() => setIsClearSearch(true)}
                      />
                    )}
                  ></Route>
                  <Route path="/deal/:dealId" component={Deal}></Route>
                  <Route path="/deals/:dealId" component={Deal}></Route>
                  <Route
                    path="/restaurants/:id/offers"
                    component={Offers}
                  ></Route>
                  <Route path="/restaurants/:id" component={Restaurant}></Route>
                  <Route path="/vouchers" component={Vouchers}></Route>
                  <Route path="/my-reviews" component={MyReviews}></Route>
                  <Route path="/redemption-voucher" component={RedemptionVoucher}></Route>
                  <Route path="/h5/" component={H5}></Route>
                </Switch>
              </main>
              <Platform></Platform>
            </div>
          </ConfigProvider>
        </Router>
      </Auth>
    </>
  );
}

async function bootstrap() {
  const WithHotReload = process.env.NODE_ENV === "production" ? App : hot(App);
  // 是否是正确的url
  let hasHash = location.href.indexOf("/#/") > -1;
  if (!hasHash) {
    let url = [
      location.protocol,
      "//",
      location.href.split("/")[2], // host
      "/#/",
      location.href.split("#/")[1], // path and query
    ].join("");
    console.log("payment redirect", url);
    if (url.indexOf("payment=") > -1) {
      location.replace(url);
    }
  }
  if (window.matchMedia) {
    setMode(window.matchMedia("(prefers-color-scheme: dark)"));
  }
  document.body.classList.add(window.top === window ? "is-top" : "is-iframe");
  ReactDOM.render(<WithHotReload />, document.getElementById("root"));
}

function setMode({ matches }) {
  const ismac = /macintosh|mac os x/i.test(navigator.userAgent);
  if (ismac) {
    document.body.classList.add("is-mac-os");
  }
  document.body.classList.add(matches ? "dark-mode" : "light-mode");
}

function setReferrer() {
  window.referrer = document.referrer;
  window.addEventListener("message", (event) => {
    if (event.data?.type === "setReferrer") {
      window.referrer = event.data.referrer;
    }
  });
  window.parent.postMessage({ type: "requestReferrer" }, "*");
}

setReferrer();

bootstrap();
